import { PolicyData } from '@core/utils/models/policy.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpError } from '@shared/utils/models/http.model';

export const PolicyActions = createActionGroup({
  source: 'Policy',
  events: {
    /** user agreement */
    'Get User Agreement': emptyProps(),
    'Get User Agreement Success': props<{ data: PolicyData }>(),
    'Get User Agreement Failure': props<{ error: HttpError }>(),
    /** terms of use */
    'Get Terms Of Use': emptyProps(),
    'Get Terms Of Use Success': props<{ data: PolicyData }>(),
    'Get Terms Of Use Failure': props<{ error: HttpError }>(),
    /** privacy policy */
    'Get Privacy Policy': emptyProps(),
    'Get Privacy Policy Success': props<{ data: PolicyData }>(),
    'Get Privacy Policy Failure': props<{ error: HttpError }>(),
  },
});

export const PolicyResetActions = createActionGroup({
  source: 'Policy',
  events: {
    'Cancel Policy Actions': emptyProps(),
    'Cancel Policy Actions Success': emptyProps(),
    'Reset Policy': emptyProps(),
  },
});
